// Importar polyfill primero para asegurar que process.env esté disponible
import "./polyfills";

import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap-grid.min.css";
import "bootstrap/dist/css/bootstrap-utilities.min.css";
import "./css/bootstrap-components.css";
import "./css/layout.css";
import "./css/responsive.css";
import "./config/i18next-config";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HelmetProvider } from "react-helmet-async";
import { ActualLangProvider } from "./contexts/ActualLangContext";
import { ContentLayoutProvider } from "./contexts/ContentLayoutContext";
import { AuthStrapiProvider } from "./contexts/AuthStrapiV3Context";
import { SolutionsProvider } from "./components/home/Solutions/context/ContentSolutionsContext";
import { AIFrameworkProvider } from "./components/aiFramework/context/ContentAIFrameworkContext";
const rootElement = document.getElementById("root");
const hasPrerenderedContent = rootElement.hasChildNodes();

const AppWithProviders = (
  <React.StrictMode>
    <HelmetProvider>
      <AuthStrapiProvider>
        <ActualLangProvider>
          <ContentLayoutProvider>
            <SolutionsProvider>
              <AIFrameworkProvider>
                <App />
              </AIFrameworkProvider>
            </SolutionsProvider>
          </ContentLayoutProvider>
        </ActualLangProvider>
      </AuthStrapiProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// Use hydrate for prerendered content, render for development
if (hasPrerenderedContent) {
  ReactDOM.hydrate(AppWithProviders, rootElement);
} else {
  ReactDOM.render(AppWithProviders, rootElement);
}

reportWebVitals();
